export default {
  addToEnquiry: "Add to Enquiry | Added to Enquiry",
  benefitsText: "Benefits",
  detailsText: "Details",
};
